import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { activeViolationsTab, GLOBAL_ALERT_BANNER_TYPES } from '../constants';
import {
  type AlertBannerState,
  type GlobalState,
  type SystemDataThemeType,
} from '../types';

import * as apiActions from './globalApis';

const initialState: GlobalState = {
  dataTheme: null as SystemDataThemeType,
  globalDateFormat: 'MMM dd, yyyy',
  isGlobalLoading: true,
  isGlobalError: false,
  globalErrorReason: '',
  activeViolationsTab,
  mediaQueryValue: 0,
  alertBanner: {
    kind: GLOBAL_ALERT_BANNER_TYPES.INFO,
    title: '',
    description: '',
    isOpen: false,
  },
  isClassicExpAlertOpen: false, // IS_READ_ONLY
  hasAAGAccess: null, // Controls whether user has access to AAG (null = not determined yet)
};

const globalSlice = createSlice({
  name: 'aag/global',
  initialState,
  reducers: {
    setViolationsActiveTab: (state, action: PayloadAction<string>) => {
      state.activeViolationsTab = action.payload;
      state.isGlobalLoading = true;
    },
    setGlobalDateFormat: (state, action: PayloadAction<string>) => {
      state.globalDateFormat = action.payload;
    },
    setIsGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isGlobalLoading = action.payload;
    },
    setGlobalError: (
      state,
      action: PayloadAction<{ state: boolean; reason?: string }>
    ) => {
      state.isGlobalError = action.payload.state;
      state.globalErrorReason = action.payload.reason ?? '';
    },
    updateScreenSize: (state, action: PayloadAction<number>) => {
      if (state.mediaQueryValue !== action.payload) {
        state.mediaQueryValue = action.payload;
      }
    },
    setAlertBanner: (state, action: PayloadAction<AlertBannerState>) => {
      state.alertBanner = action.payload;
    },
    // IS_READ_ONLY
    setIsClassisExperience: (state, action: PayloadAction<boolean>) => {
      state.isClassicExpAlertOpen = action.payload;
    },
    setHasAAGAccess: (state, action: PayloadAction<boolean>) => {
      state.hasAAGAccess = action.payload;
    },
  },
});

const { reducer: globalReducer, actions } = globalSlice;

export const globalActions = {
  ...actions,
  ...apiActions,
};

export default globalReducer;
